export const getPageParam = (page: number) => {
  return page ? `&page=${page}` : ''
}
